import Vue from 'vue'

let bus = new Vue({name: 'ModalsBus'})

bus.open = function () {
  if (arguments.length === 3 && arguments[2].onClose) {
    bus.$once('close', (e, arg) => {
      if (e === arguments[0]) {
        arguments[2].onClose()
      }
    })
  }
  bus.$emit.apply(bus, ['open'].concat([...arguments]))
}

bus.onOpen = function () {
  bus.$on.apply(bus, ['open'].concat([...arguments]))
}

bus.closeAll = function () {
  bus.$emit.apply(bus, ['closeAll'].concat([...arguments]))
}

bus.onCloseAll = function () {
  bus.$on.apply(bus, ['closeAll'].concat([...arguments]))
}

bus.close = function () {
  bus.$emit.apply(bus, ['close'].concat([...arguments]))
}
bus.onClose = function () {
  bus.$on.apply(bus, ['close'].concat([...arguments]))
}
bus.offClose = function () {
  bus.$off.apply(bus, ['close'].concat([...arguments]))
}

bus.modals = {
  CREATE_EVENT: 'CREATE_EVENT',
  COPY_EVENT: 'COPY_EVENT',
  IMPORT_ICS: 'IMPORT_ICS',
  EDIT_ANSWER: 'EDIT_ANSWER',
  OPEN_SHARED_OBJECT: 'OPEN_SHARED_OBJECT',
  CONFIGURE_CALENDAR: 'CONFIGURE_CALENDAR',
  OPEN_GROUP_ACCOUNT: 'OPEN_GROUP_ACCOUNT',
  CREATE_POLL: 'CREATE_POLL',
  COPY_POLL: 'COPY_POLL',
  CONNECTION: 'CONNECTION',
  CREATE_GROUP: 'CREATE_GROUP',
  CREATE_MEMBERS: 'CREATE_MEMBERS',
  CHAT_WITH: 'CHAT_WITH',
  MANAGE_RESTRICTED_VIEWERS: 'MANAGE_RESTRICTED_VIEWERS',
  SELECT_A_GROUP: 'SELECT_A_GROUP'
}

export default bus



// WEBPACK FOOTER //
// ./src/components/shared/ModalsBus.js